import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { OrderStatus } from './../../services/insecta/insecta.models';

import { cloneDeep } from 'lodash-es';

import { MenuItem, MessageService, TreeNode } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { Popover, PopoverModule } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { TooltipModule } from 'primeng/tooltip';
import { firstValueFrom, forkJoin } from 'rxjs';

import { SETTINGS, Settings } from '../../app.settings';

import { notifyAndTrackError } from '../../common/error';
import { getItemDescriptionColumn, isNotEmpty, isNotStringEmpty, isStringEmpty, isStringEqual, parseLocalDate } from '../../common/functions';
import { errorMsg, successMsg, warningMsg } from '../../common/messages';

import { AddressBookComponent, CanComponentDeactivate, EmailComponent, ProcessingComponent, SubmitUpdatedDialogComponent } from '../../components';

import { AppInsightsService } from '../../services/app-insights.service';

import { AppInitService, IInsectaPermissions } from '../../services/app-init.service';
import {
  GrowthStageAdminService,
  IAppUser,
  IGrowthStageMappedGetRequest,
  ILocation,
  IOrder,
  IOrderItemSearchRequest,
  IOrderUpdateRequest,
  ISearchFilter,
  OrderItemInstanceStatus,
  OrderItemStatus,
  SearchService
} from '../../services/insecta';
import { OrderItemTypeService } from '../../services/insecta/order-item-type.service';
import { OrderService } from '../../services/insecta/order.service';
import { OrderItemService } from '../../services/insecta/orderitem.service';
import { MSGraphService } from '../../services/msgraph.service';
import { OrderInsectComponent } from './order-insect-item';
import { OrderInsectSubstrateComponent } from './order-insect-substrate-item/order-insect-substrate.component';
import { OrderSubstrateComponent } from './order-substrate-item';

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BreadcrumbModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    ContextMenuModule,
    CommonModule,
    DialogModule,
    FloatLabelModule,
    FieldsetModule,
    FormsModule,
    InputTextModule,
    MultiSelectModule,
    PopoverModule,
    RouterModule,
    SelectModule,
    TableModule,
    TextareaModule,
    ToggleSwitchModule,
    TreeSelectModule,
    TreeTableModule,
    TooltipModule,
    ProcessingComponent,
    AddressBookComponent,
    EmailComponent,
    OrderInsectComponent,
    OrderInsectSubstrateComponent,
    OrderSubstrateComponent,
    SubmitUpdatedDialogComponent,
    ButtonModule
  ],

  templateUrl: 'order-details.component.html'
})
export class OrderDetailsComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  @ViewChild('cancelPopover') cancelPopover!: Popover;
  @ViewChild('editPopover') editPopover!: Popover;

  permissions!: IInsectaPermissions;
  locationNodes: TreeNode[] = [];
  locationEnabled = false;
  locations: ILocation[] = [];
  locationId: string = ``;
  projects: any[] = [];
  catalogInformation: any[] = [];
  orderInfo: IOrder = <IOrder>{};
  orderItems: any[] = [];
  orderStatus: string = ``;
  orderId: string = ``;
  siteLabel: string = ``;
  titleOrderItemSeq: any;
  titleInstanceSeq: any;
  modalTitle: string = '';
  projectTooltipText: string =
    'Use Cost Center to attribute your order to your research group.';
  status = {
    Orders: OrderStatus,
    Items: OrderItemStatus,
    Instances: OrderItemInstanceStatus
  };
  showInsectOnly = false;
  showSubstrateOnly = false;
  showInsectAndSubstrate = false;
  showSubstrateModal = false;
  showInsectSubstrateModal = false;
  showInsectModal = false;
  dialogConfirmSub: ((leave: boolean) => void) | null = null;
  showSubmitUpdatedDialog = false;
  submitUpdatedDialogConfirmSub: ((decision: 'submit' | 'cancel') => void) | null = null;
  cancelInstanceId!: string;

  dialogVars: any = {
    location: null,
    title: `Update Order`
  };

  emailVars: any = {
    showWindow: false,
    toList: [`jonathan.walsh@corteva.com`],
    ccList: [],
    subject: `Some really boring email`
  };

  pageVars: any = {
    currentUser: ``,
    isEditing: false,
    isReady: false,
    isRequester: undefined,
    pageId: `Dashboard:OrderDetails`,
    breadcrumbItems: <MenuItem[]>[],
    source: ``
  };

  expandedOrderIds: Set<string> = new Set();
  expandedRows = {};
  selectedDelegates: string[] = [];
  selectedAlternateOwners: string[] = [];
  alternateOwnerUI: string[] = [];
  notificationDetails: any[] = [];
  instance: {
    OrderId: string | null;
    OrderItemId: string | null;
    OrderItemTypeName: string | null;
  } = {
      OrderId: null,
      OrderItemId: null,
      OrderItemTypeName: null
    };
  selectedOrderItem: any;
  editing: boolean = false;
  editingInstance: boolean = false;
  selectedEditInstance: any;
  editingMode: string = '';
  editingStatusInstances: string = '';
  isLastInstance: boolean = false;

  columnMap: { [key: string]: any[] } = {
    'Insect': [
      { field: 'OrderItemInstanceSequence', header: 'Instance ID' },
      { field: 'OrderItemInstanceStatus', header: 'Status' },
      { field: 'InsectQuantity', header: 'Insect Quantity' },
      { field: 'PermitName', header: 'Permit' },
      { field: 'InfestationRateQuantity', header: 'Infestation Rate' },
      { field: 'Note', header: 'Note' },
      { field: 'DeliveryDate', header: 'Delivery Date' },
      { field: 'DeliveryLocation', header: 'Delivery Location' }
    ],
    'Substrate': [
      { field: 'OrderItemInstanceSequence', header: 'Instance ID' },
      { field: 'OrderItemInstanceStatus', header: 'Status' },
      { field: 'SubstrateQuantity', header: 'Substrate Quantity' },
      { field: 'SubstrateAmountUom', header: 'Amount' },
      { field: 'Note', header: 'Note' },
      { field: 'DeliveryDate', header: 'Delivery Dates' },
      { field: 'DeliveryLocation', header: 'Delivery Location' }
    ],
    'Insect + Substrate': [
      { field: 'OrderItemInstanceSequence', header: 'Instance ID' },
      { field: 'OrderItemInstanceStatus', header: 'Status' },
      { field: 'InsectQuantity', header: 'Insect Quantity' },
      { field: 'PermitName', header: 'Permit' },
      { field: 'InfestationRateQuantity', header: 'Infestation Rate' },
      { field: 'SubstrateAmountUom', header: ' Amount' },
      { field: 'Note', header: 'Note' },
      { field: 'DeliveryDate', header: 'Delivery Date' },
      { field: 'DeliveryLocation', header: 'Delivery Location' }
    ]
  };

  inactiveGrowthStageWhileEditing: IGrowthStageMappedGetRequest | any = null;

  appUser?: IAppUser;
  userSettingsJson: { [key: string]: any } = {};
  itemDescName: string = 'ItemDescription';

  constructor(
    private appInitService: AppInitService,
    private orderService: OrderService,
    private orderItemService: OrderItemService,
    private searchService: SearchService,
    private appInsights: AppInsightsService,
    private graphService: MSGraphService,
    private msgService: MessageService,
    private orderItemTypeService: OrderItemTypeService,
    private router: Router,
    private route: ActivatedRoute,
    private appInit: AppInitService,
    private growthStageService: GrowthStageAdminService,
    @Inject(SETTINGS) private settings: Settings
  ) {
    this.pageVars.pageId = `${settings.environment}:Dashboard:Requesterdashboard`;
    appInsights.trackPageView(this.pageVars.pageId, `/dashboard/orderdetails`);
  }

  ngOnDestroy() {
    this.locations = [];
    this.orderInfo = <IOrder>{};
    this.pageVars = {
      isReady: false
    };
  }

  canDeactivate(): Promise<boolean> {
    const hasUpdatedInstances = this.orderItems.some((item: any) =>
      item.Instances.some((inst: any) => isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated))
    );

    if (!hasUpdatedInstances) {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      this.showSubmitUpdatedDialog = true;
      this.submitUpdatedDialogConfirmSub = (decision: 'submit' | 'cancel') => {
        this.submitUpdatedDialogConfirmSub = null;
        if (decision === 'submit') {
          this.submitUpdatedInstances();
          resolve(true);
        } else {
          resolve(true);
        }
      };
    });
  }

  onSubmitUpdatedDialogDecision(decision: 'submit' | 'cancel') {
    this.showSubmitUpdatedDialog = false;
    if (this.submitUpdatedDialogConfirmSub) {
      this.submitUpdatedDialogConfirmSub(decision);
    }
  }

  ngOnInit() {
    this.appUser = this.appInit.appUser;
    if (this.appUser) {
      if (!isStringEmpty(this.appUser.userSettingsJson) || this.appUser.userSettingsJson === '{}') {
        this.userSettingsJson = JSON.parse(this.appUser.userSettingsJson);
      } else {
        this.userSettingsJson = {};
      }
      this.itemDescName = getItemDescriptionColumn(this.userSettingsJson);
    }
    this.permissions = this.appInit.permissions;

    this.appInsights.trackEvent(`${this.pageVars.pageId}:Init`);
    this.pageVars.source = this.route.snapshot.paramMap.get('source');
    this.orderId = this.route.snapshot.paramMap.get('orderId') || '';

    const searchRequest: IOrderItemSearchRequest = {
      filters: [<ISearchFilter>{ name: `orderId`, operator: `equals`, value: this.orderId }],
      sorts: [],
      skip: 0,
      take: undefined
    };

    const request = {
      locations: this.orderService.getLocationsForHierarchy(),
      orderInfo: this.orderService.getOrderById(this.orderId),
      orderStatus: this.orderService.getOrderStatusById(this.orderId),
      allUsers: this.orderService.getNotificationDetails(),
      orderItems: this.searchService.orderItems(searchRequest),
      profile: this.graphService.getMyProfile$()
    };

    firstValueFrom(forkJoin(request))
      .then(async (response) => {
        this.pageVars.profile = response.profile;
        this.orderStatus = response.orderStatus;
        this.orderInfo = response.orderInfo;
        this.pageVars.isRequester = this.isRequester();
        this.locations = response.locations;

        const paddedSequence = this.orderInfo.orderSequence.toString().padStart(4, '0');
        const orderString = `${this.orderInfo.orderYear}${this.orderInfo.orderSiteCode}${paddedSequence}`;
        const hasBothPermissions = this.permissions.canViewInsectaryDashboard && this.permissions.canViewRequestorDashboard;

        switch (this.pageVars.source) {
          case 'requester':
          case 'insectary': {
            const dashboardType = this.pageVars.source === 'requester' ? 'Requester' : 'Insectary';
            const link = `/${this.pageVars.source}dashboard`;
            const label = hasBothPermissions ? `${dashboardType} Dashboard` : 'Dashboard';
            this.pageVars.breadcrumbItems = [{ label: label, routerLink: link }, { label: orderString }];
            break;
          }

          case 'approve': {
            this.pageVars.breadcrumbItems = [{ label: 'Approve Orders', routerLink: '/insectarydashboard/approve' }, { label: orderString }];
            break;
          }

          case 'vendor': {
            this.pageVars.breadcrumbItems = [{ label: 'Vendor Orders', routerLink: '/insectarydashboard/vendor' }, { label: orderString }];
            break;
          }

          case 'insectprep': {
            this.pageVars.breadcrumbItems = [{ label: 'Insect Prep', routerLink: '/insectarydashboard/insectprep' }, { label: orderString }];
            break;
          }

          case 'receive': {
            this.pageVars.breadcrumbItems = [{ label: 'Receive Orders', routerLink: '/requesterdashboard/receive' }, { label: orderString }];
            break;
          }

          case 'substrateprep': {
            this.pageVars.breadcrumbItems = [{ label: 'Substrate Prep', routerLink: '/insectarydashboard/substrateprep' }, { label: orderString }];
            break;
          }
        }

        await this.getCatalogInformation(this.orderInfo.catalogId);

        const deliveryLocation = response.locations.find((loc) => isStringEqual(loc.id, this.locationId));
        this.siteLabel = deliveryLocation ? deliveryLocation.name : '';

        if (deliveryLocation) {
          this.locationNodes = deliveryLocation?.children?.length
            ? deliveryLocation.children.map((child: ILocation) => this.buildNode(child))
            : [this.buildNode(deliveryLocation)];
        }

        let orderDeliveryLocationNode: TreeNode | undefined;

        if (this.locationNodes.length > 0) {
          const node = this.findNodeByKey(this.locationNodes, this.orderInfo.deliveryLocationId);
          if (node) {
            orderDeliveryLocationNode = node;
          }
        }

        this.dialogVars.location = orderDeliveryLocationNode;

        this.notificationDetails = response.allUsers.map((user: any) => ({
          name: user.displayName,
          email: user.email
        }));

        this.orderInfo.notificationJson = this.orderInfo.notificationJson || '[]';
        const currentNotifications = JSON.parse(this.orderInfo.notificationJson);
        this.selectedDelegates = currentNotifications.map((notification: any) => notification.email?.trim());

        const alternateOwnerList = this.parseAlternateOwner(this.orderInfo.alternateOwnerJson);
        this.selectedAlternateOwners = alternateOwnerList
          .map((owner: any) => owner.email?.trim())
          .filter((email: string) => !!email);
        this.alternateOwnerUI = this.selectedAlternateOwners
          .filter((email: string) => !isStringEqual(email, this.orderInfo.requester));

        this.pageVars.isRequester = this.canEdit();

        const mappedItems = new Map();
        const parsedOrderItems = JSON.parse(response.orderItems?.results || `[]`);
        const orderItems = parsedOrderItems.filter((item: any) => item.OrderItemId !== null);
        orderItems.forEach((item: any) => {
          mappedItems.set(item.OrderItemId, { ...item, Instances: item.Instances ? JSON.parse(item.Instances) : [] });
        });
        this.orderItems = Array.from(mappedItems.values()).sort((a: any, b: any) => a.OrderItemSequence - b.OrderItemSequence);
        console.log('Loaded order items:', this.orderItems);
        console.log('Order info:', this.orderInfo);
        if (
          (isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Draft) ||
            isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Submitted) ||
            isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Approved)) &&
          !this.canApprove()
        ) {
          await this.calcOrderItemMinDate();
          const itemsWithDeliveryDateIssues = this.orderItems.filter((item) => item.HasDeliveryDateIssue);
          if (itemsWithDeliveryDateIssues.length > 0) {
            warningMsg(this.msgService, 'Some order items have delivery date issues - please review the order items.');
          }
        }
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'InitLoad' });
      })
      .finally(() => {
        this.pageVars.isReady = true;
      });
  }

  onLocationChange(){
     this.orderInfo.deliveryLocationId = this.dialogVars.location?.data?.id || '';
  }

  findNodeByKey(nodes: TreeNode[], key: string): TreeNode | null {
    for (const node of nodes) {
      if (node.key === key) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = this.findNodeByKey(node.children, key);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  buildNode(location: ILocation): TreeNode {
    location.locationTypeId = location.locationTypeId.toUpperCase();
    location.containmentTypeId = location.containmentTypeId?.toUpperCase();
    if (isNotEmpty(location.address)) {
      location.address!.privateUserId = location.address!.privateUserId?.toUpperCase();
    }
    const childrenNodes = (location?.children || []).map((x) => this.buildNode(x));

    return {
      key: location.id,
      label: location.name,
      data: location,
      selectable: location.isSelectable,
      children: childrenNodes
    };
  }

  onAddressListChanged(updatedList: string[]) {
    this.selectedDelegates = updatedList.map((email) => email.trim());
  }

  onAlternateOwnersListChanged(updatedList: string[]) {
    this.alternateOwnerUI = updatedList.map((email) => email.trim());
  }

  formattedOrderNumber(): string {
    if (!this.orderInfo) return '';
    const year = this.orderInfo.orderYear?.toString() || '';
    const site = this.orderInfo.orderSiteCode || '';
    const seq = this.orderInfo.orderSequence?.toString().padStart(4, '0') || '';
    return `${year}${site}${seq} - ${this.orderStatus}`;
  }

  private parseAlternateOwner(value: string | null | undefined): any[] {
    if (!value || value.trim() === '') {
      return [];
    }
    
    const trimmed = value.trim();
  
    if (trimmed.startsWith('[')) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return [];
      }
    }
    
    return [{ name: trimmed, email: trimmed }];
  }

  private async getCatalogInformation(catalogId: string) {
    try {
      const catalogInfo = await firstValueFrom(this.orderItemService.getCatalogInformationParsed(catalogId));
      this.catalogInformation = (catalogInfo as any[]).map((catalogInformation: any) => {
        const parsedCatInformation = JSON.parse(catalogInformation.CatalogInformationJson);
        return {
          CatalogId: parsedCatInformation.CatalogId,
          CatalogInsectId: parsedCatInformation.CatalogInsectId,
          ScientificName: parsedCatInformation.ScientificName,
          CommonName: parsedCatInformation.CommonName,
          InsectId: parsedCatInformation.InsectId,
          LocationId: parsedCatInformation.LocationId,
          Variants: JSON.parse(parsedCatInformation.Variants),
          Containers: JSON.parse(parsedCatInformation.Containers),
          GrowthStages: JSON.parse(parsedCatInformation.GrowthStages),
          Substrates: JSON.parse(parsedCatInformation.Substrates),
          OrderItemTypes: JSON.parse(parsedCatInformation.OrderItemTypes),
          Projects: JSON.parse(parsedCatInformation.Projects)
        };
      });
      const mappedProjects = new Map();
      const catalogProjects = this.catalogInformation.flatMap((x) => x.Projects || []);
      catalogProjects.forEach((p) => {
        const key = `${p.CatalogId}:${p.ProjectId}`;
        mappedProjects.set(key, p);
      });
      this.projects = Array.from(mappedProjects.values());

      this.showInsectOnly = this.catalogInformation[0].OrderItemTypes.some((x: any) => x.OrderItemTypeName === 'Insect');
      this.showSubstrateOnly = this.catalogInformation[0].OrderItemTypes.some((x: any) => x.OrderItemTypeName === 'Substrate');
      this.showInsectAndSubstrate = this.catalogInformation[0].OrderItemTypes.some((x: any) => x.OrderItemTypeName === 'Insect + Substrate');

      this.locationId = this.catalogInformation[0].LocationId.toString() || '';
    } catch (error) {
      notifyAndTrackError(this.msgService, this.appInsights, error, { component: 'OrderDetailsComponent', action: 'LoadCatalogInfo' });
    }
  }

  private async calcOrderItemMinDate() {
    try {
      const orderItems = this.orderInfo.orderItems as any[];
      const itemsToProcess = orderItems.filter((item) => {
        if (!item) return false;

        const deliveryDate = item.firstDeliveryDate;
        return deliveryDate && typeof deliveryDate === 'string' && deliveryDate.length > 0 && deliveryDate.trim() !== '';
      });
      if (itemsToProcess.length === 0) {
        return;
      }

      const allPromises = itemsToProcess.map(async (item: any) => {
        const data = await firstValueFrom(this.orderItemTypeService.getOrderItemConstraints(this.orderInfo.catalogId, item.id));
        const minDate = parseLocalDate(data.minDate);
        const orderItem = this.orderItems.find((oi: any) => isStringEqual(oi.OrderItemId, item.id));
        if (orderItem) {
          if (
            orderItem.OrderItemStatus === OrderItemStatus.Draft ||
            orderItem.OrderItemStatus === OrderItemStatus.Submitted ||
            orderItem.OrderItemStatus === OrderItemStatus.Approved
          ) {
            const earliestInstanceDate = this.getMinDateFromActiveInstances(orderItem.Instances);
            if (earliestInstanceDate) {
              orderItem.HasDeliveryDateIssue = earliestInstanceDate < minDate;
            } else {
              orderItem.HasDeliveryDateIssue = false;
            }
          }
        }
      });

      await Promise.all(allPromises);
    } catch (error) {
      notifyAndTrackError(this.msgService, this.appInsights, error, { component: 'OrderDetailsComponent', action: 'CalcOrderItemMinDate' });
    }
  }

  getMinDateFromActiveInstances(instances: any[]): Date | null {
    const activeInstances = instances.filter((inst: any) => {
      const isValidStatus =
        isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Draft) ||
        isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Submitted) ||
        isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated);

      return isValidStatus && inst.DeliveryDate;
    });

    if (activeInstances.length === 0) {
      return null;
    }

    const earliestDate = activeInstances.reduce((min: Date, inst: any) => {
      const currentInstDate = parseLocalDate(inst.DeliveryDate);
      return currentInstDate < min ? currentInstDate : min;
    }, parseLocalDate(activeInstances[0].DeliveryDate));

    return earliestDate;
  }

  getColumns(orderType: string) {
    return this.columnMap[orderType] || [];
  }

  openInsectModal() {
    if (this.selectedOrderItem != null) {
      this.onCheckGrowthStageInactive(this.selectedOrderItem);
    }
    if (this.orderInfo && this.orderInfo.catalogId) {
      this.selectedOrderItem = null;
      this.editing = false;
      this.editingInstance = false;
      this.editingMode = '';
      this.selectedEditInstance = null;
      this.editingStatusInstances = '';
      this.showInsectModal = true;
      this.modalTitle = 'Insect Only';
    } else {
      warningMsg(this.msgService, 'Order information not loaded yet');
    }
  }

  onDialogCloseInsect() {
    if (this.editing) {
      this.editing = false;
      this.selectedOrderItem = null;
      this.editingInstance = false;
      this.editingMode = '';
    }
    this.showInsectModal = false;
    this.pageVars.isReady = false;
    this.loadOrderItems();
  }

  onDialogCancelInsect() {
    this.showInsectModal = false;
    this.pageVars.isReady = true;
    this.editing = false;
    this.editingInstance = false;
  }

  openSubstrateModal() {
    if (this.selectedOrderItem != null) {
      this.onCheckGrowthStageInactive(this.selectedOrderItem);
    }
    if (this.orderInfo && this.orderInfo.catalogId) {
      this.selectedOrderItem = null;
      this.editing = false;
      this.editingInstance = false;
      this.editingMode = '';
      this.selectedEditInstance = null;
      this.editingStatusInstances = '';
      this.showSubstrateModal = true;
      this.modalTitle = 'Substrate Only';
    } else {
      warningMsg(this.msgService, 'Order information not loaded yet');
    }
  }

  onDialogCloseSubstrate() {
    if (this.editing) {
      this.editing = false;
      this.selectedOrderItem = null;
      this.editingInstance = false;
      this.editingMode = '';
    }
    this.showSubstrateModal = false;
    this.pageVars.isReady = false;
    this.loadOrderItems();
  }

  onDialogCancelSubstrate() {
    this.showSubstrateModal = false;
    this.pageVars.isReady = true;
    this.editing = false;
    this.editingInstance = false;
  }

  openInsectSubstrateModal() {
    if (this.selectedOrderItem != null) {
      this.onCheckGrowthStageInactive(this.selectedOrderItem);
    }
    if (this.orderInfo && this.orderInfo.catalogId) {
      this.selectedOrderItem = null;
      this.editing = false;
      this.editingInstance = false;
      this.editingMode = '';
      this.selectedEditInstance = null;
      this.editingStatusInstances = '';
      this.showInsectSubstrateModal = true;
      this.modalTitle = 'Insect + Substrate';
    } else {
      warningMsg(this.msgService, 'Order information not loaded yet');
    }
  }

  onDialogCloseInsectSubstrate() {
    if (this.editing) {
      this.editing = false;
      this.selectedOrderItem = null;
      this.editingInstance = false;
      this.editingMode = '';
    }
    this.showInsectSubstrateModal = false;
    this.pageVars.isReady = false;
    this.loadOrderItems();
  }

  onDialogCancelInsectSubstrate() {
    this.showInsectSubstrateModal = false;
    this.pageVars.isReady = true;
  }

  async loadOrderItems() {
    try {
      const tempOrderItems = cloneDeep(this.orderItems);
      const searchRequest: IOrderItemSearchRequest = {
        filters: [<ISearchFilter>{ name: `orderId`, operator: `equals`, value: this.orderInfo.id }],
        sorts: [],
        skip: 0,
        take: 100
      };

      const request = {
        orderStatus: this.orderService.getOrderStatusById(this.orderId),
        orderItems: this.searchService.orderItems(searchRequest)
      };

      const response = await firstValueFrom(forkJoin(request));
      const orderItem = JSON.parse(response.orderItems.results || `[]`);
      const uniqueOrderItems = orderItem.filter(
        (item: any, index: number, self: any[]) => index === self.findIndex((t: any) => t.OrderItemId === item.OrderItemId)
      );

      this.orderItems = uniqueOrderItems
        .map((item: any) => {
          const originalItem = tempOrderItems.find((x) => isStringEqual(x.OrderItemId, item.OrderItemId));
          return {
            ...item,
            Instances: item.Instances ? JSON.parse(item.Instances) : [],
            HasDeliveryDateIssue: originalItem ? originalItem.HasDeliveryDateIssue : false
          };
        })
        .sort((a: any, b: any) => a.OrderItemSequence - b.OrderItemSequence);

      if (
        (isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Draft) ||
          isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Submitted) ||
          isStringEqual(this.orderStatus.toUpperCase(), OrderStatus.Approved)) &&
        !this.canApprove()
      ) {
        await this.calcOrderItemMinDate();
        const itemsWithDeliveryDateIssues = this.orderItems.filter((item) => item.HasDeliveryDateIssue);
        if (itemsWithDeliveryDateIssues.length > 0) {
          warningMsg(this.msgService, 'Some order items have delivery date issues - please review the order items.');
        }
      }

      this.orderStatus = response.orderStatus;
      this.pageVars.isReady = true;
    } catch (error) {
      console.error('Failed to load order items:', error);
      errorMsg(this.msgService, 'Failed to load order items');
    }
  }

  setWorkflowStatus(entity: string, entityId: string, status: string): void {
    if (entity === 'Order' && isStringEqual(status, OrderStatus.Submitted)) {
      const itemsWithDeliveryDateIssues = this.orderItems.filter((item) => item.HasDeliveryDateIssue);
      if (itemsWithDeliveryDateIssues.length > 0) {
        warningMsg(this.msgService, 'Some order items have delivery date issues - please review the order items');
        return;
      }
    }

    this.pageVars.isReady = false;
    firstValueFrom(this.orderService.setWorkflowStatus(entity, entityId, status, ''))
      .then(() => {
        successMsg(this.msgService, `${entity} successfully ${status}`);
        if (entity === 'Order') {
          this.pageVars.isReady = true;
          this.navigateToSource();
        } else {
          this.loadOrderItems();
        }
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'SetWorkflowStatus' });
      });
  }

  setWorkFlowStatusInstancesOnly(entity: string, status: string, instancesIds: string[]): void {
    this.pageVars.isReady = false;
    firstValueFrom(this.orderService.setWorkFlowStatusInstancesOnly(entity, status, instancesIds))
      .then(() => {
        successMsg(this.msgService, `${entity} successfully ${status}`);
        this.pageVars.isReady = true;
        this.loadOrderItems();
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'SetWorkflowStatusInstancesOnly' });
      });
  }

  submitOrder() {
    this.pageVars.isReady = false;
    firstValueFrom(this.orderService.setWorkflowStatus(`Order`, this.orderInfo.id, OrderStatus.Submitted, undefined))
      .then(() => {
        this.orderStatus = 'Submitted';
        successMsg(this.msgService, 'Order successfully Submitted');
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'SubmitOrder' });
      })
      .finally(() => {
        this.pageVars.isReady = false;
      });
  }

  updateOrder(): void {
    this.pageVars.isReady = false;
    const notifications = this.notificationDetails.filter((detail) => this.selectedDelegates.includes(detail.email?.trim()));
    
    const requesterDetail = this.notificationDetails.find((detail) => isStringEqual(detail.email?.trim(), this.orderInfo.requester));
    const alternateOwnerNotifications = this.notificationDetails.filter((detail) => this.alternateOwnerUI.includes(detail.email?.trim()));
    const allAlternateOwners = requesterDetail 
      ? [requesterDetail, ...alternateOwnerNotifications.filter((o) => !isStringEqual(o.email?.trim(), this.orderInfo.requester))]
      : alternateOwnerNotifications;
    
    const updateRequest: IOrderUpdateRequest = {
      id: this.orderInfo.id,
      deliveryLocationId: this.dialogVars.location?.data?.id,
      orderName: this.orderInfo.orderName || '',
      notificationJson: JSON.stringify(notifications),
      alternateOwnerJson: JSON.stringify(allAlternateOwners)
    };
    this.locationId = this.dialogVars.location?.data?.id || '';
    firstValueFrom(this.orderService.updateOrder(updateRequest))
      .then(() => {
        this.pageVars.isReady = true;
        successMsg(this.msgService, 'Order information updated successfully');
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'UpdateOrder' });
      });
  }

  copyOrder(): void {

    const requesterDetail = this.notificationDetails.find((detail) => isStringEqual(detail.email?.trim(), this.orderInfo.requester));
    const alternateOwnerNotifications = this.notificationDetails.filter((detail) => this.alternateOwnerUI.includes(detail.email?.trim()));
    const allAlternateOwners = requesterDetail 
    ? [requesterDetail, ...alternateOwnerNotifications.filter((o) => !isStringEqual(o.email?.trim(), this.orderInfo.requester))]
    : alternateOwnerNotifications;

    firstValueFrom(this.orderService.copyOrder(this.orderInfo.id, JSON.stringify(allAlternateOwners), '[]'))
      .then((response) => {
        successMsg(this.msgService, 'Order copied successfully! Redirecting to new order...');
        this.router.navigateByUrl(`/orders/${response.newOrderId}/requester`).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'CopyOrder' });
      });
  }

  orderEmail() {
    const year = this.orderInfo.orderYear?.toString() || '';
    const site = this.orderInfo.orderSiteCode || '';
    const seq = this.orderInfo.orderSequence?.toString().padStart(4, '0') || '';

    let subject = `Order ${year}${site}${seq}`;
    if (isNotStringEmpty(this.orderInfo.orderName)) subject = `${subject} - ${this.orderInfo.orderName}`;

    this.emailVars.toList = [this.orderInfo.requester];
    this.emailVars.toList = [this.orderInfo.requester].concat(this.alternateOwnerUI);
    this.emailVars.ccList = this.selectedDelegates;
    this.emailVars.subject = subject;
    this.emailVars.showWindow = true;
  }

  editOrderItem(item: any) {
    this.editing = true;
    this.editingInstance = false;
    const orderItemId = item.OrderItemId;
    this.pageVars.isEditing = true;
    this.titleOrderItemSeq = item.OrderItemSequence;
    firstValueFrom(this.orderItemService.getOrderItem(item.OrderId, orderItemId))
      .then((orderItemDetails) => {
        this.selectedOrderItem = orderItemDetails;
        this.selectedOrderItem.OrderItemTypeName = item.OrderItemTypeName;
        this.onCheckGrowthStageInactive(this.selectedOrderItem, true);
        this.modalTitle = this.getModalTitle();
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'EditOrderItem' });
      });
  }

  orderItemEmail(item: any) {
    let subject = `Order Item ${item.OrderItemSequence}`;
    if (isNotStringEmpty(item.ItemDescription)) subject = `${subject} - ${item.ItemDescription}`;

    this.emailVars.toList = [this.orderInfo.requester];
    this.emailVars.toList = this.emailVars.toList.concat(this.alternateOwnerUI);
    this.emailVars.ccList = this.selectedDelegates;
    this.emailVars.subject = subject;
    this.emailVars.showWindow = true;
  }

  setOrderItemInstanceCancel() {
    this.pageVars.isReady = false;

    firstValueFrom(this.orderService.setWorkflowStatus('OrderItemInstance', this.cancelInstanceId, OrderItemInstanceStatus.Cancelled, 'single'))
      .then(() => {
        this.loadOrderItems();
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'SetOrderItemInstanceCancel' });
      })
      .finally(() => {
        this.cancelInstanceId = undefined!;
        this.cancelPopover.hide();
      });
  }

  setOrderItemInstanceFollowingCancel() {
    this.pageVars.isReady = false;

    firstValueFrom(this.orderService.setWorkflowStatus('OrderItemInstance', this.cancelInstanceId, OrderItemInstanceStatus.Cancelled, 'future'))
      .then(() => {
        this.cancelInstanceId = undefined!;
        this.loadOrderItems();
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, {
          component: 'OrderDetailsComponent',
          action: 'SetOrderItemInstanceFollowingCancel'
        });
      })
      .finally(() => {
        this.cancelInstanceId = undefined!;
        this.cancelPopover.hide();
      });
  }

  submitUpdatedInstances() {
    const updatedInstances = this.orderItems
      .flatMap((item) => item.Instances)
      .filter((inst) => isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated))
      .map((inst) => inst.OrderItemInstanceId);
    if (updatedInstances.length > 0) {
      this.setWorkFlowStatusInstancesOnly('OrderItemInstance', OrderItemInstanceStatus.Submitted, updatedInstances);
    }
  }

  editOrderItemInstance(instance: any, mode: 'single' | 'future') {
    this.editing = true;
    this.editingInstance = true;
    this.editingMode = mode;
    const orderItemId = instance.OrderItemId;
    this.pageVars.isEditing = true;
    this.editPopover.hide();
    this.titleInstanceSeq = instance.OrderItemInstanceSequence;
    if (
      instance.OrderItemInstanceStatus === OrderItemInstanceStatus.Approved ||
      instance.OrderItemInstanceStatus === OrderItemInstanceStatus.Updated
    ) {
      if (this.canApprove()) {
        this.editingStatusInstances = 'Approved';
      } else {
        this.editingStatusInstances = 'Updated';
      }
    } else {
      this.editingStatusInstances = instance.OrderItemInstanceStatus;
    }

    firstValueFrom(this.orderItemService.getOrderItem(instance.OrderId, orderItemId))
      .then((orderItemDetails) => {
        this.selectedOrderItem = orderItemDetails;
        this.selectedEditInstance = this.selectedOrderItem.orderItemInstances.find((i: any) => isStringEqual(i.id, instance.OrderItemInstanceId));
        this.selectedOrderItem.OrderItemTypeName = instance.OrderItemTypeName;
        this.onCheckGrowthStageInactive(this.selectedOrderItem, true);
        this.modalTitle = this.getModalTitle();
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'OrderDetailsComponent', action: 'EditOrderItemInstance' });
      });
  }

  toggleCancelPopover(event: any, instanceId: any) {
    this.cancelInstanceId = instanceId;
    this.cancelPopover.toggle(event);
  }

  toggleEditPopover(event: any, instanceId: string, item: any, index: number) {
    this.isLastInstance = index === item.Instances.length - 1;
    this.instance = item.Instances.find((i: any) => i.OrderItemInstanceId === instanceId);
    this.instance.OrderId = item.OrderId;
    this.instance.OrderItemId = item.OrderItemId;
    this.instance.OrderItemTypeName = item.OrderItemTypeName;
    this.editPopover.toggle(event);
  }

  navigateToSource() {
    const target = isStringEqual(this.pageVars.source, 'requester') ? `requesterdashboard` : `insectarydashboard/approve`;
    this.router.navigateByUrl(`/${target}`);
  }

  getModalTitle(): string {
    if (!this.editing || !this.selectedOrderItem) {
      if (this.showInsectModal) return 'Insect Only';
      if (this.showSubstrateModal) return 'Substrate Only';
      if (this.showInsectAndSubstrate) return 'Insect + Substrate';
      return '';
    }
    const itemId = this.titleOrderItemSeq;
    if (this.editingInstance) {
      const instanceId = this.titleInstanceSeq;
      if (this.showInsectModal) return `Insect Only (${instanceId})`;
      if (this.showSubstrateModal) return `Substrate Only (${instanceId})`;
      if (this.showInsectAndSubstrate) return `Insect + Substrate (${instanceId})`;
      return '';
    } else {
      if (this.showInsectModal) return `Insect Only (${itemId})`;
      if (this.showSubstrateModal) return `Substrate Only (${itemId})`;
      if (this.showInsectAndSubstrate) return `Insect + Substrate (${itemId})`;
      return '';
    }
  }

  isRequester() {
    return isStringEqual(this.appInitService.appUser.email, this.orderInfo.requester);
  }

  isAlternateOwner() {
    return this.selectedAlternateOwners.some((email) => isStringEqual(this.appInitService.appUser.email, email));
  }

  canEdit() {
    return this.isAlternateOwner();
  }

  isDelegate() {
    return this.selectedDelegates.some((delegate) => isStringEqual(this.appInitService.appUser.email, delegate));
  }

  canApprove() {
    return this.permissions.insectaryApproveOrders;
  }

  // -------- Buttons ---------
  // Order Item Type Buttons
  isInsectOnlyVisible(orderStatus: string) {
    return this.showInsectOnly && isStringEqual(orderStatus, OrderStatus.Draft) && this.pageVars.isReady && this.pageVars.isRequester;
  }

  isSubstrateOnlyVisible(orderStatus: string) {
    return this.showSubstrateOnly && isStringEqual(orderStatus, OrderStatus.Draft) && this.pageVars.isReady && this.pageVars.isRequester;
  }

  isInsectSubstrateVisible(orderStatus: string) {
    return this.showInsectAndSubstrate && isStringEqual(orderStatus, OrderStatus.Draft) && this.pageVars.isReady && this.pageVars.isRequester;
  }

  // Copy Order Button
  isCopyOrderVisible(): boolean {
    const hasOrderItemsWithoutInstances = this.orderItems.some((item: any) => item.Instances.length === 0);
    return this.pageVars.isReady && this.orderInfo && this.orderInfo.id && this.orderItems.length > 0 && !hasOrderItemsWithoutInstances;
  }

  // Submit buttons
  isOrderSubmitVisible(orderStatus: string) {
    const itemsWithDeliveryDateIssues = this.orderItems.filter((item: any) => item.HasDeliveryDateIssue);
    const hasOrderItemsWithoutInstances = this.orderItems.some((item: any) => item.Instances.length === 0);
    return (
      this.pageVars.isReady &&
      itemsWithDeliveryDateIssues.length === 0 &&
      this.orderItems.length > 0 &&
      this.pageVars.isRequester &&
      isStringEqual(orderStatus, OrderStatus.Draft) &&
      !hasOrderItemsWithoutInstances
    );
  }

  isOrderItemInstanceSubmitVisible() {
    const itemsWithDeliveryDateIssues = this.orderItems.filter((item: any) => item.HasDeliveryDateIssue);
    const hasUpdated = this.orderItems.some((item: any) =>
      item.Instances.some((inst: any) => isStringEqual(inst.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated))
    );
    return this.orderItems.length > 0 && itemsWithDeliveryDateIssues.length === 0 && this.pageVars.isReady && this.pageVars.isRequester && hasUpdated;
  }

  // Email buttons
  isOrderEmailVisible(orderStatus: string) {
    return this.pageVars.isReady && this.canApprove() && isStringEqual(orderStatus, OrderStatus.Draft) === false;
  }

  isOrderItemEmailVisible(orderStatus: string, itemStatus: string) {
    return this.pageVars.isReady && this.canApprove() && isStringEqual(itemStatus, OrderItemStatus.Draft) === false;
  }

  // Deny buttons
  isOrderDenyVisible(orderStatus: string) {
    return this.canApprove() && isStringEqual(orderStatus, OrderStatus.Submitted) && this.pageVars.isReady;
  }

  isOrderItemDenyVisible(orderStatus: string, itemStatus: string) {
    return this.canApprove() && isStringEqual(itemStatus, OrderItemStatus.Submitted) && this.pageVars.isReady;
  }

  isOrderItemInstanceDenyVisible(orderStatus: string, itemStatus: string, instanceStatus: string) {
    return this.canApprove() && isStringEqual(instanceStatus, OrderItemInstanceStatus.Submitted) && this.pageVars.isReady;
  }

  // Edit Buttons
  isOrderItemEditVisible(orderStatus: string, itemStatus: string) {
    if (this.canEdit()) {
      return (isStringEqual(itemStatus, OrderItemStatus.Draft) || isStringEqual(itemStatus, OrderItemStatus.Submitted)) && this.pageVars.isReady;
    }
    if (this.canApprove()) {
      return isStringEqual(itemStatus, OrderItemStatus.Submitted) && this.pageVars.isReady;
    }
    return false;
  }

  isOrderItemInstanceEditVisible(orderStatus: string, item: any, instance: any) {
    if (this.canApprove()) {
      if (this.canEdit()) {
        return (
          ((isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Draft) && item.Instances.length > 1) ||
            (isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Submitted) && item.Instances.length > 1) ||
            isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Approved) ||
            isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated)) &&
          this.pageVars.isReady
        );
      } else {
        return (
          ((isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Submitted) && item.Instances.length > 1) ||
            isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Approved) ||
            isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated)) &&
          this.pageVars.isReady
        );
      }
    } else {
      if (this.canEdit()) {
        if (
          ((isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Draft) && item.Instances.length > 1) ||
            (isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Submitted) && item.Instances.length > 1) ||
            isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Updated)) &&
          this.pageVars.isReady
        ) {
          return true;
        } else if (isStringEqual(instance.OrderItemInstanceStatus, OrderItemInstanceStatus.Approved) && this.pageVars.isReady) {
          if (instance.LastEditableDate === null || instance.LastEditableDate === undefined) {
            return false;
          } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let lastEditableDate: Date | null = null;
            lastEditableDate = new Date(instance.LastEditableDate);
            lastEditableDate.setHours(0, 0, 0, 0);
            return today <= lastEditableDate;
          }
        }
      } else {
        return false;
      }
    }
  }

  // Delete Buttons
  isOrderItemDeleteVisible(orderStatus: string, itemStatus: string) {
    return isStringEqual(itemStatus, OrderItemStatus.Draft) && this.pageVars.isReady && this.pageVars.isRequester;
  }

  isOrderItemInstanceDeleteVisible(orderStatus: string, item: any, instanceStatus: string) {
    return (
      isStringEqual(instanceStatus, OrderItemInstanceStatus.Draft) && this.pageVars.isReady && this.pageVars.isRequester && item.Instances.length > 1
    );
  }

  // Approve buttons
  isOrderApproveVisible(orderStatus: string) {
    return this.canApprove() && isStringEqual(orderStatus, OrderStatus.Submitted) && this.pageVars.isReady;
  }

  isOrderItemApproveVisible(orderStatus: string, itemStatus: string) {
    return this.canApprove() && isStringEqual(itemStatus, OrderItemStatus.Submitted) && this.pageVars.isReady;
  }

  isOrderItemInstanceApproveVisible(orderStatus: string, itemStatus: string, instanceStatus: string) {
    return this.canApprove() && this.pageVars.isReady && isStringEqual(instanceStatus, OrderItemInstanceStatus.Submitted);
  }

  // Cancel buttons
  isOrderItemCancelVisible(orderStatus: string, itemStatus: string) {
    if (this.pageVars.isReady === false) return false;

    if (this.canEdit()) {
      return isStringEqual(itemStatus, OrderItemStatus.Submitted) || isStringEqual(itemStatus, OrderItemStatus.Approved);
    }
    if (this.canApprove()) {
      return isStringEqual(itemStatus, OrderItemStatus.Approved);
    }

    return false;
  }

  isOrderItemInstanceCancelVisible(orderStatus: string, itemStatus: string, instanceStatus: string) {
    if (this.pageVars.isReady === false) return false;

    if (this.canEdit()) {
      return (
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Submitted) ||
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Approved) ||
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Updated) ||
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Delayed)
      );
    }
    if (this.canApprove()) {
      return (
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Approved) ||
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Updated) ||
        isStringEqual(instanceStatus, OrderItemInstanceStatus.Delayed)
      );
    }
    return false;
  }

  async onCheckGrowthStageInactive(selectedOrderItem: any, isEditMode: boolean = false) {
    if (this.inactiveGrowthStageWhileEditing != null && this.inactiveGrowthStageWhileEditing != undefined) {
      const catalogInfo = this.catalogInformation.find(
        (info: any) => info.CatalogInsectId.toUpperCase() === this.inactiveGrowthStageWhileEditing.catalogInsectId.toUpperCase()
      );

      if (!catalogInfo) return;

      const index = this.catalogInformation.indexOf(catalogInfo);

      if (this.inactiveGrowthStageWhileEditing?.catalogInsectGrowthStageId !== null) {
        catalogInfo.GrowthStages = catalogInfo.GrowthStages.filter(
          (gs: any) => !isStringEqual(gs.CatalogInsectGrowthStageId, this.inactiveGrowthStageWhileEditing?.catalogInsectGrowthStageId.toUpperCase())
        );
      }

      if (this.inactiveGrowthStageWhileEditing?.catalogContainerInsectGrowthStageId !== null) {
        catalogInfo.Containers = catalogInfo.Containers.filter(
          (con: any) =>
            !isStringEqual(
              con.CatalogContainerInsectGrowthStageId,
              this.inactiveGrowthStageWhileEditing?.catalogContainerInsectGrowthStageId.toUpperCase()
            )
        );
      }

      if (this.inactiveGrowthStageWhileEditing?.catalogInsectVariantId !== null) {
        catalogInfo.Variants = catalogInfo.Variants.filter(
          (variant: any) => !isStringEqual(variant.CatalogInsectVariantId, this.inactiveGrowthStageWhileEditing?.catalogInsectVariantId.toUpperCase())
        );
      }

      this.catalogInformation[index] = {
        ...catalogInfo,
        GrowthStages: [...catalogInfo.GrowthStages],
        Containers: [...catalogInfo.Containers],
        Substrates: [...catalogInfo.Substrates]
      };
      this.inactiveGrowthStageWhileEditing = null;

      if (isEditMode === false) {
        if (selectedOrderItem.OrderItemTypeName === 'Insect') {
          this.showInsectModal = true;
        } else if (selectedOrderItem.OrderItemTypeName === 'Substrate') {
          this.showSubstrateModal = true;
        } else if (selectedOrderItem.OrderItemTypeName === 'Insect + Substrate') {
          this.showInsectSubstrateModal = true;
        }
      }
    }
    if (isEditMode === false) {
      return;
    }
    if (selectedOrderItem.OrderItemTypeName !== 'Insect' && selectedOrderItem.OrderItemTypeName !== 'Insect + Substrate') {
      if (selectedOrderItem.OrderItemTypeName === 'Insect') {
        this.showInsectModal = true;
      } else if (selectedOrderItem.OrderItemTypeName === 'Substrate') {
        this.showSubstrateModal = true;
      } else if (selectedOrderItem.OrderItemTypeName === 'Insect + Substrate') {
        this.showInsectSubstrateModal = true;
      }
      return;
    }
    const containerSelected = this.catalogInformation
      .flatMap((info: any) => info.Containers)
      .find((container: any) => isStringEqual(container.CatalogContainerInsectGrowthStageId, selectedOrderItem.catalogContainerInsectGrowthStageId));

    const catalogInsectGrowthStageIdSelected = containerSelected?.CatalogInsectGrowthStageId;

    const growthStageSelected = this.catalogInformation
      .flatMap((info: any) => info.GrowthStages)
      .find((gs: any) => isStringEqual(gs.CatalogInsectGrowthStageId, catalogInsectGrowthStageIdSelected));

    const variantSelected = this.catalogInformation
      .flatMap((info: any) => info.Variants)
      .find((variant: any) => isStringEqual(variant.CatalogInsectVariantId, this.selectedOrderItem.catalogInsectVariantId));

    if (growthStageSelected == undefined || growthStageSelected == null || variantSelected == undefined || variantSelected == null) {
      if ((growthStageSelected == undefined || growthStageSelected == null) && (variantSelected == undefined || variantSelected == null)) {
        await this.getGrowthStageMapped(selectedOrderItem.catalogContainerInsectGrowthStageId, selectedOrderItem.catalogInsectVariantId);
      } else if (growthStageSelected == undefined || growthStageSelected == null) {
        await this.getGrowthStageMapped(selectedOrderItem.catalogContainerInsectGrowthStageId);
      } else if (variantSelected == undefined || variantSelected == null) {
        await this.getGrowthStageMapped(undefined, selectedOrderItem.catalogInsectVariantId);
      }

      if (growthStageSelected == undefined || growthStageSelected == null) {
        const GrowthStage = {
          CatalogId: this.inactiveGrowthStageWhileEditing?.catalogId.toUpperCase(),
          CatalogInsectGrowthStageId: this.inactiveGrowthStageWhileEditing?.catalogInsectGrowthStageId.toUpperCase(),
          CatalogInsectId: this.inactiveGrowthStageWhileEditing?.catalogInsectId.toUpperCase(),
          InsectGrowthStageId: this.inactiveGrowthStageWhileEditing?.insectGrowthStageId.toUpperCase(),
          InsectId: this.inactiveGrowthStageWhileEditing?.insectId.toUpperCase(),
          GrowthStageName: this.inactiveGrowthStageWhileEditing?.growthStageName,
          LeadTime: this.inactiveGrowthStageWhileEditing?.leadTime
        };
        const catalogInfo = this.catalogInformation.find(
          (info: any) => info.CatalogInsectId.toUpperCase() === this.inactiveGrowthStageWhileEditing?.catalogInsectId.toUpperCase()
        );
        const index = this.catalogInformation.indexOf(catalogInfo);
        if (!catalogInfo.GrowthStages.some((gs: any) => isStringEqual(gs.CatalogInsectGrowthStageId, GrowthStage.CatalogInsectGrowthStageId))) {
          catalogInfo.GrowthStages.push(GrowthStage);
        }
        const container = {
          CatalogContainerInsectGrowthStageId: this.inactiveGrowthStageWhileEditing.catalogContainerInsectGrowthStageId.toUpperCase(),
          CatalogContainerId: this.inactiveGrowthStageWhileEditing?.containerId.toUpperCase(),
          ContainerName: this.inactiveGrowthStageWhileEditing?.containerName,
          ContainerTypeName: this.inactiveGrowthStageWhileEditing?.containerTypeName,
          InfestationRate: this.inactiveGrowthStageWhileEditing?.infestationRate,
          IsAvailable: this.inactiveGrowthStageWhileEditing?.isAvailable,
          CatalogInsectGrowthStageId: this.inactiveGrowthStageWhileEditing?.catalogInsectGrowthStageId.toUpperCase(),
          CatalogInsectId: this.inactiveGrowthStageWhileEditing?.catalogInsectId.toUpperCase(),
          ContainerId: this.inactiveGrowthStageWhileEditing?.containerId.toUpperCase()
        };
        if (
          !catalogInfo.Containers.some((con: any) =>
            isStringEqual(con.CatalogContainerInsectGrowthStageId, container.CatalogContainerInsectGrowthStageId)
          )
        ) {
          catalogInfo.Containers.push(container);
        }

        this.catalogInformation[index] = catalogInfo;
      }
      if (variantSelected == undefined || variantSelected == null) {
        const Variant = {
          CatalogId: this.inactiveGrowthStageWhileEditing?.catalogId.toUpperCase(),
          CatalogInsectVariantId: this.inactiveGrowthStageWhileEditing?.catalogInsectVariantId.toUpperCase(),
          CatalogInsectId: this.inactiveGrowthStageWhileEditing?.catalogInsectId.toUpperCase(),
          InsectVariantId: this.inactiveGrowthStageWhileEditing?.insectVariantId.toUpperCase(),
          InsectId: this.inactiveGrowthStageWhileEditing?.insectId.toUpperCase(),
          VariantName: this.inactiveGrowthStageWhileEditing?.variantName,
          VariantTypeName: this.inactiveGrowthStageWhileEditing?.variantTypeName,
          LeadTime: this.inactiveGrowthStageWhileEditing?.variantLeadTime,
          SiteCode: this.inactiveGrowthStageWhileEditing?.siteCode ?? ''
        };
        const catalogInfo = this.catalogInformation.find(
          (info: any) => info.CatalogInsectId.toUpperCase() === this.inactiveGrowthStageWhileEditing?.catalogInsectId.toUpperCase()
        );

        const index = this.catalogInformation.indexOf(catalogInfo);
        if (!catalogInfo.Variants.some((v: any) => isStringEqual(v.CatalogInsectVariantId, Variant.CatalogInsectVariantId))) {
          catalogInfo.Variants.push(Variant);
        }
        this.catalogInformation[index] = catalogInfo;
      }
    }
    if (selectedOrderItem.OrderItemTypeName === 'Insect') {
      this.showInsectModal = true;
    } else if (selectedOrderItem.OrderItemTypeName === 'Substrate') {
      this.showSubstrateModal = true;
    } else if (selectedOrderItem.OrderItemTypeName === 'Insect + Substrate') {
      this.showInsectSubstrateModal = true;
    }
  }

  getGrowthStageMapped(catalogContainerInsectGrowthStage?: string, catalogInsectVariantId?: string): Promise<void> {
    this.pageVars.isReady = false;
    return firstValueFrom(this.growthStageService.getGrowthStagesMapped(catalogContainerInsectGrowthStage, catalogInsectVariantId))
      .then((result: IGrowthStageMappedGetRequest) => {
        this.inactiveGrowthStageWhileEditing = result;
        this.pageVars.isReady = true;
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, {
          component: 'InsectItemComponent',
          action: 'GetGrowthStageMapped'
        });
        this.pageVars.isReady = true;
      });
  }
}
